import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cn from 'classnames';
import { Breadcrumbs } from '@crossroads/ui-components';
import styles from 'shop-views/Breadcrumbs.scss';

var _excluded = ["className"];

var Delimeter = () => /*#__PURE__*/React.createElement("span", {
  className: styles.delimeter
}, "/");

var CustomBreadcrumbs = _ref => {
  var className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Breadcrumbs, _extends({}, rest, {
    className: cn(styles.block, className),
    Delimeter: Delimeter
  }));
};

export { CustomBreadcrumbs };
//# sourceMappingURL=index.js.map
